<template>
  <div id="budgetreport">
    <Printer title="Budget & Receipts">
      <template v-slot:printContent>
        <div
          id="budgetSummary"
          v-if="showBudgetSummary && budgetInfo && headerInfo"
        >
          <report-budget-header
            v-if="headerInfo"
            :report-header="headerInfo"
            title="Budget Summary"
          />
          <div class="p-2 page">
            <budget-summary
              :budget-info="budgetInfo"
              :cell-style="cellStyle"
              :header-cell-style="headerCellStyle"
            />
          </div>
        </div>
        <div
          id="budgetDetails"
          v-if="showBudgetDetails && budgetInfo && headerInfo"
        >
          <report-budget-header
            v-if="headerInfo"
            :report-header="headerInfo"
            title="Budget Details"
          />
          <div class="p-2 page">
            <report-budget-details
              :editable="false"
              :budget-info="budgetInfo"
            />
          </div>
        </div>
        <div
          id="reimbursementSummary"
          v-if="showReimbursementSummary && headerInfo"
        >
          <report-budget-header
            v-if="headerInfo"
            :report-header="headerInfo"
            title="Reimbursement Summary"
          />
          <div class="p-2 page">
            <report-reimbursement-summary
              :reimbursement-summaries="reimbursementSummaries"
            />
          </div>
        </div>
        <div
          id="reimbursementDetails"
          v-if="showReimbursementDetails && headerInfo"
        >
          <report-budget-header
            v-if="headerInfo"
            :report-header="headerInfo"
            title="Reimbursement Details"
          />
          <div class="p-2 page">
            <report-reimbursement-details
              :reimbursement-details="reimbursementDetails"
            />
          </div>
        </div>
        <div
          id="receipts"
          v-if="showReceipts && headerInfo"
        >
          <report-budget-header
            v-if="headerInfo"
            :report-header="headerInfo"
            title="Receipts"
          />
          <report-receipts
            :reimbursement-details="reimbursementDetails"
          />
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import BudgetSummary from '@/components/finance/budget-summary.vue'
import ReportBudgetHeader from '@/components/reports/budget/report-budget-header.vue'
import ReportBudgetDetails from '@/components/reports/budget/report-budget-details.vue'
import ReportReimbursementSummary from '@/components/reports/budget/report-reimbursement-summary.vue'
import ReportReimbursementDetails from '@/components/reports/budget/report-reimbursement-details.vue'
import ReportReceipts from '@/components/reports/budget/report-receipts.vue'
import reportsApi from '@/services/api/reports.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'ReportBudget',
  props: {
    showBudgetSummary: {
      type: Boolean,
      default: null
    },
    showBudgetDetails: {
      type: Boolean,
      default: null
    },
    showReimbursementSummary: {
      type: Boolean,
      default: null
    },
    showReimbursementDetails: {
      type: Boolean,
      default: null
    },
    showReceipts: {
      type: Boolean,
      default: null
    }
  },
  components: {
    BudgetSummary,
    ReportBudgetHeader,
    ReportBudgetDetails,
    ReportReimbursementSummary,
    ReportReimbursementDetails,
    ReportReceipts,
    Printer
  },
  data: function () {
    return {
      loading: true,
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'overflow-wrap': 'break-word'
      },
      budgetInfo: {
        Budget: {},
        ScouterExpenses: {
          Details: [],
          Summary: {}
        },
        AdminExpenses: {
          Details: []
        },
        Consumables: {
          Details: [],
          Summary: {}
        },
        Food: {
          Details: [],
          Summary: {}
        },
        OtherExpenses: {
          Details: [],
          Summary: {}
        },
        RegistrationIncome: {
          Details: [],
          Summary: {}
        },
        OtherIncome: {
          Details: [],
          Summary: {}
        },
        Contingencies: {
          Details: [],
          Summary: {}
        }
      },
      headerInfo: {},
      reimbursementSummaries: [],
      reimbursementDetails: [],
      tempHolding: null
    }
  },
  mounted () {
    // Get all the data, instead of selecting subsets due to an order of operations
    // issue that I don't want to fix right now.
    reportsApi
      .getFinanceReport(this.$root.courseKey, true, true, true, true, true)
      .then(x => {
        this.budgetInfo = x.Budget
        this.headerInfo = x.Header
        this.reimbursementSummaries = x.ReimbursementSummaries
        this.reimbursementDetails = x.ReimbursementDetails
        this.tempHolding = x
      })
      .catch(error => {
        console.log(error)
        this.errormessage = error
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
